import { ReactElement, ReactNode } from 'react';
import CollapsedControllerContext from './collapsed-controller-context';
import useCollapsedControllerValue from './hooks/use-collapsed-controller-value';

const CollapsedControllerProvider = ({ children }: { readonly children: ReactNode }): ReactElement => {
  const value = useCollapsedControllerValue();

  return <CollapsedControllerContext value={value}>{children}</CollapsedControllerContext>;
};

export default CollapsedControllerProvider;
